import React, { useContext, useEffect } from 'react'
import StoreContext from '../../providers/storesContext'
import { ChevronLeftIcon } from '@heroicons/react/outline'
import { Link, useHistory } from 'react-router-dom'
import { caseReleaseUrl, caseReleaseDropOffUrl, caseDetailUrl } from '../../routing/paths'
import { topBarStore } from '../../../lib/stores/TopBarStore'
import SuccessMessage from '../../components/SuccessMessage'
import Button from '../../components/Button'

const CaseSelfReleaseSuccess = () => {
  const history = useHistory()
  const { caseDetailStore } = useContext(StoreContext)
  const { immobilizationCase } = caseDetailStore

  useEffect(() => {
    if (!(immobilizationCase.isSelfRelease || immobilizationCase.isBootboxed)) {
      history.push(caseDetailUrl(immobilizationCase))
    }

    topBarStore.setTitle('Self release')
  }, [])

  return (
    <SuccessMessage
      subtitle={<div className='text-gray-600'>Click on the button below to find the nearest drop-off to your location.</div>}
      title="You've successfully removed the boot!"
      footer={
        <Button as={Link} to={caseReleaseDropOffUrl(immobilizationCase)}>
          Find nearby drop-off
        </Button>
      }
    />
  )
}

export default CaseSelfReleaseSuccess
